import { useMemo } from 'react';
import { useInstagramResourceActivation } from 'src/components/pages/instagram-channel/shared/hooks';
import { useMetaResourceActivation } from 'src/components/pages/whatsapp-channel/shared/hooks';
import { useAuthorization } from 'src/hooks/use-authorization';
import { useSetHeaderActions } from 'src/hooks/use-set-header-actions';
import { HeaderAction } from 'src/services/header-actions.service';

export function useSetLegacyHeaderActions(headerActionsElement: HTMLDivElement | null) {
  const { getFeatureFlag } = useAuthorization();
  const { launchWhatsAppSignUp } = useMetaResourceActivation();
  const { launchInstagramPermissionGrant } = useInstagramResourceActivation();

  const isResourcePage = RegExp('^.*tracking/resources/?$').test(
    window.location.pathname,
  );

  const actions = useMemo(() => {
    const extraLinks: HeaderAction[] = [];
    if (isResourcePage && getFeatureFlag('channel_whatsapp')) {
      extraLinks.push({
        label: 'WhatsApp Number',
        icon: 'whatsapp',
        type: 'button',
        href: '',
        onClick: launchWhatsAppSignUp,
        isLegacy: false,
      });
    }

    if (
      getFeatureFlag('channel_instagram') &&
      (isResourcePage ||
        RegExp('^.*settings/instagram/?$').test(window.location.pathname))
    ) {
      extraLinks.push({
        label: 'Instagram Account',
        icon: 'instagram',
        type: 'button',
        href: '',
        onClick: launchInstagramPermissionGrant,
        isLegacy: false,
        color: 'smalt',
      });
    }

    return extraLinks;
  }, [
    launchWhatsAppSignUp,
    launchInstagramPermissionGrant,
    getFeatureFlag,
    isResourcePage,
  ]);

  const legacyActions = useMemo(() => {
    if (headerActionsElement) {
      const text = headerActionsElement.innerText;
      const arr = JSON.parse(text) as HeaderAction[];

      for (const action of arr) {
        const parsedUrl = new URL(action.href, new URL(window.location.href).origin);
        action.href = `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
        action.isLegacy = true;
      }
      return arr;
    }
    return [];
  }, [headerActionsElement]);

  useSetHeaderActions([...actions, ...legacyActions]);
}
